<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Tester</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-btn color="primary" dark class="mb-2" small @click="createTester" v-if="$store.state.currentPagePriv.create">
                        <v-icon small>mdi-plus</v-icon>
                        Add Tester
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewData(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editData(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        headers: [
            { text: 'Tester Id', value: 'tester_id' },
            { text: 'Delivery Date', value: 'delivery_date' },
            { text: 'Coordinator', value: 'coordinator_name', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false }
        ],
        items: [],
        search: '',
    }),

    created() {
        this.initialize();
    },

    methods: {
        async initialize() {
            let response = await this.$store.dispatch('tester/getObjs');
            if (response.data.status == 'success') {
                this.items = response.data.data;
            }
        },
        async createTester() {
            this.$router.push('/tester/new');
        },
        viewData(item) {
            this.$router.push(`/tester/view/${item.tester_id}`);
        },
        editData(item) {
            this.$router.push(`/tester/${item.tester_id}`);
        }
    }
}
</script>